import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { Validation } from '@feature/validation';
import { generateValidationApi, generateValidationOptions } from '@feature/validation/validationGenerator';

const validationApi = generateValidationApi('/validation/dictionary');

const { getHistoryOptions, validateOptions, getCurrentOptions } = generateValidationOptions(
  'dictionary',
  validationApi,
);

export function getDictionaryValidationHistoryOptions(dictionaryId: Id): UseSuspenseQueryOptions<Validation[]> {
  return getHistoryOptions(dictionaryId);
}

export function getDictionaryValidationOptions(dictionaryId: Id): UseSuspenseQueryOptions<Validation | null> {
  return getCurrentOptions(dictionaryId);
}

export function useValidateDictionary(dictionaryId: Id) {
  const queryClient = useQueryClient();
  return useMutation(validateOptions(dictionaryId, queryClient));
}
